import Card from "components/Card";
import CheckedComponent from "components/CheckedComponent";
import { ALL_PLAN_FEATURES } from "constants/planFeatures";
import { useActiveSubscription } from "routes/data-routes/billing-data/active-subscription";


export default function PlanFeaturesCard() {
  const { activeSubscription } = useActiveSubscription();
  const planName = activeSubscription?.planName || "your";

  return (
    <Card size="XL">
      <div className="flex flex-col gap-2">
        <h3 className="text-2xl font-semibold text-gray-900">
          Features included in your {planName} Plan
        </h3>
        <p className="text-sm text-gray-600">
          Everything included in your plan
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-[72px] gap-y-4">
        {ALL_PLAN_FEATURES.map((feature, index) => (
          <CheckedComponent key={'feature-' + index} variant="outline" className="text-sm">
            {feature}
          </CheckedComponent>
        ))}
      </div>
    </Card>
  );
}
